/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogTitle, FormHelperText, InputAdornment, TextField } from '@mui/material';
import { BsFolder } from 'react-icons/bs';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { LanguageContext } from '../../../../libs/Context';
import Card from './components/MoveCard';
import { useSelector } from 'react-redux';
import Loading from '../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { getFolder, moveFolder } from '../../../actions/media_actions';
import { MediaContext } from '../..';
import useDebounce from '../../../../components/Hooks/useDebounce';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useGetMyFolders from '../../customHooks/useGetMyFolder';

const MoveToFolder = (props:any) =>
{
	const { optionsData, handlePopup } = props;
	const { language } = useContext(LanguageContext);
	const { mediaState, setMediaState, tab } = useContext(MediaContext);
	const userData = useSelector((state:any) => state.mysession.session);
	const [ searchValue, setSearchValue ] = useState<any>('');
	const debounceSearchTerm = useDebounce(searchValue, 500);
	const [ folders, setFolders ] = useState<any>([]);
	const [ page, setPage ] = useState<number>(0);
	const [ loading, setLoading ] = useState<boolean>(false);
	const [ selected, setSelected ] = useState<any>({});
	const newCount = useRef<number>(0);
	const seacrhRef = useRef<any>('');
	const searchErrRef = useRef('');
	const folderId = useParams()?.id || '';
	const userId = useParams()?.userId || '';
	const getFoldersData = useGetMyFolders({});
	const circleLoader = useRef(false);

	const handleChange = (event) =>
	{
		setSearchValue(event?.target?.value.replace(/^\s/, ''));
		Object.keys(selected)?.length > 0 && setSelected({});
	};

	const handleClose = () =>
	{
		handlePopup({ move: false });
	};

	const LoadMore = () =>
	{
		if (!loading && !circleLoader.current && folders?.length < newCount.current)
		{
			circleLoader.current = true;
			setPage(page + 1);
		}
	};

	const folderIds = mediaState?.selectedData?.map((item) => item?.folderId);
	const id = folderIds?.join('##');

	const query: any = {
		uid       : userData?.userId,
		comid     : userData?.companyId,
		empRole   : userData?.empRole,
		role      : userData?.role,
		limit     : 12,
		skip      : page,
		folderIds : id?.length > 0 ? id : optionsData?.folderId
	};

	if (tab === 2 && userId)
	{
		query.ownerId = userId;
	}

	if (folderId)
	{
		query.parentId = folderId;
	}

	const getCount = async () =>
	{
		query.count = true;

		if (searchValue)
		{
			query.search = searchValue;
		}
		try
		{
			const res = await getFolder(query, 'move');

			if (res?.status)
			{
				newCount.current = res?.count;
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	const getFolderData = async () =>
	{
		if (page === 0)
		{
			setLoading(true);
		}
		else
		{
			circleLoader.current = true;
		}
		if (searchValue)
		{
			query.search = searchValue;
		}
		try
		{
			const res = await getFolder(query, 'move');

			if (res.status)
			{
				const filterData = res?.data?.filter((item:any) => item?.folderId !== folderId);

				if (page === 0)
				{
					if (res?.data.length >= 12)
					{
						getCount();
					}
					else
					{
						newCount.current = res?.data.length;
					}

					setFolders(filterData);
					if (res?.data?.length <= 0 && searchValue !== '')
					{
						searchErrRef.current = `${language.noresultsearch} '${searchValue}'`;
					}
				}
				else
				{
					setFolders([ ...folders, ...filterData ]);
				}

				if (page === 0)
				{
					setLoading(false);
				}
				else
				{
					circleLoader.current = false;
				}
			}
		}
		catch (err)
		{
			console.log(err);
			if (page === 0)
			{
				setLoading(false);
			}
			else
			{
				circleLoader.current = true;
			}
		}
	};

	const moveToFolders = async () =>
	{
		setLoading(true);

		const queryParam: any = {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role
		};

		const body:any = {
			folderIds      : folderIds?.length > 0 ? folderIds : optionsData?.folderId,
			targetFolderId : selected?.folderId
		};

		if (tab === 2 && userId)
		{
			body.ownerId = userId;
		}

		try
		{
			const res = await moveFolder(queryParam, body);

			if (res?.status)
			{
				toast.success(language?.folderMovedSuccessfully, {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});
				mediaState?.page > 0
					? setMediaState({ type: 'updateReducer', payload: { page: 0 } })
					: getFoldersData();
				setLoading(false);
				setSelected({});
				mediaState?.selectedData?.length > 0 && setMediaState({ type: 'updateReducer', payload: { selectedData: [], allSelected: false } });
				handleClose();
			}
		}
		catch (err:any)
		{
			setLoading(false);
			console.log(err);
		}
	};

	useEffect(() =>
	{
		getFolderData();
	}, [ page ]);

	useEffect(() =>
	{
		if (seacrhRef.current !== searchValue)
		{
			seacrhRef.current = searchValue;
			getFolderData();
			searchErrRef.current = '';
			setPage(0);
		}
	}, [ debounceSearchTerm ]);

	return (
		<Dialog
			open
			fullWidth
			maxWidth='md'
			className='shareDialog'
		>
			<DialogTitle id='responsive-dialog-title'>
				<div className='flexRow alignCntr'>
					<div className='flexMinWidthRow alignEnd'>
						<h2 className='mainHdngTxtSM pdngRSM'>{language.move}</h2>
						<span>
							<BsFolder className='primaryTxt' fontSize='var(--pixel24)' />
						</span>
						<span className='mainHdngTxtSM pdngLSM ellipsisTxt'>
							{mediaState?.selectedData?.length > 0
								? mediaState?.selectedData?.length > 1 ? `${mediaState?.selectedData?.length} ${language?.folders}` : mediaState?.selectedData[0]?.name
								: optionsData?.name}
						</span>
					</div>
					<button tabIndex={0}
						onKeyUp={(e) => { e.key === 'Enter' && handleClose(); }}
						className='flexAutoRow pdngLSM'
						onClick={handleClose}
					>
						<CloseIcon className='pointer pointer' />
					</button>
				</div>
			</DialogTitle>
			<div className='flexRow pdngMD mrgnTXS brdrTSM'>
				{language.destinationfolder}
			</div>
			<div className='flexRow pdngHMD'>
				<TextField
					placeholder={language.searchDot}
					id='search'
					name='search'
					value={searchValue}
					onChange={handleChange}
					InputProps={{
						type           : 'search',
						startAdornment : (
							<InputAdornment position='start'>
								<SearchIcon />
							</InputAdornment>
						)
					}}
					className='modeGray'
					fullWidth
					size='small'
				/>
			</div>
			{searchErrRef.current && searchValue !== '' && (
				<FormHelperText id='txtPhone-error' className='errorTxt pdngHMD'>
					{searchErrRef.current}
				</FormHelperText>
			)}
			<div className='flexMinHeightCol scrollY pdngMD'>
				{loading && <Loading />}
				{!loading && folders?.length > 0
					? folders.map((item:any, index:any) => (
						<Card key={item?.id} item={item} index={index} filterData={folders} LoadMore={LoadMore} selected={selected} setSelected={setSelected}/>
					))
					: !loading && searchValue === '' && <span className='flexCol alignCntr  justifyCntr'>{language?.noFoldersFound}</span>}
				{circleLoader.current && <div className='flexRow justifyCntr'><CircularProgress /></div>}
			</div>
			<DialogActions>
				<div className='flexRow justifyEnd'>
					<Button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleClose(); }} onClick={handleClose}>{language.cancel}</Button>
					<Button

						variant='contained'
						className='whiteTxt'
						disabled={!selected?.folderId}
						onClick={moveToFolders}
					>
						{language.move}
					</Button>
				</div>
			</DialogActions>
		</Dialog>
	);
};

export default MoveToFolder;